import { useContext, useMemo } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import ReactTooltip from "components/ReactTooltip";
import { DataStoreContext } from "../DataStore/DataStoreContext";
import {
  getBackendChannelInfo,
  getBackendChannelTitle,
  getFrontendChannelInfo,
  resolveCurrentBackendChannel,
  resolveCurrentBackendSettings,
} from "./channelInfo";
import { ChannelBadgeSubLabel, ChannelLabel } from "./style";

const ChannelBadgeTooltip = styled(ReactTooltip)`
  &.fr-tooltip {
    font-size: 12px;
    line-height: 1.3;
    text-align: left;
  }
`;

const CurrentChannelBadge = ({ mobile = false }) => {
  const { state } = useContext(DataStoreContext);
  const location = useLocation();
  const frontendChannelInfo = useMemo(() => getFrontendChannelInfo(), []);
  const { backendChannelTitle, backendChannelInfo } = useMemo(() => {
    const backendSettings = resolveCurrentBackendSettings({
      pathname: location.pathname,
      state,
    });
    const backendChannel = resolveCurrentBackendChannel({
      pathname: location.pathname,
      state,
    });

    return {
      backendChannelTitle: getBackendChannelTitle(backendChannel),
      backendChannelInfo: getBackendChannelInfo(backendSettings),
    };
  }, [location.pathname, state]);

  const tooltipId = !mobile ? "channelLabel" : null;
  const tooltipContent = useMemo(() => {
    const sections = [];

    if (frontendChannelInfo.title) {
      const frontendDescription = frontendChannelInfo.tooltip ? ` ${frontendChannelInfo.tooltip}` : "";
      sections.push(`<div><strong>${frontendChannelInfo.title}</strong> frontend: ${frontendDescription}</div>`);
    }

    if (backendChannelInfo?.title) {
      const backendUrl = backendChannelInfo.url ? ` ${backendChannelInfo.url}` : "";
      sections.push(`<div><strong>${backendChannelInfo.title}</strong> backend: ${backendUrl}</div>`);
    }

    if (frontendChannelInfo.title || backendChannelInfo?.title) {
      sections.push(`<div>Change this in User, Organization or Scenario Settings</div>`);
    }

    return sections.join("<br/>") || null;
  }, [frontendChannelInfo, backendChannelInfo]);

  if (!frontendChannelInfo.label && !backendChannelTitle) return null;

  return (
    <ChannelLabel
      data-for={tooltipId || undefined}
      data-tip={tooltipId ? tooltipContent : undefined}
      $mobile={mobile}
      $withSubLabel={!!backendChannelTitle}
    >
      {frontendChannelInfo.label && <span>{frontendChannelInfo.label}</span>}
      {backendChannelTitle && <ChannelBadgeSubLabel>{backendChannelTitle}</ChannelBadgeSubLabel>}
      {tooltipId && tooltipContent && (
        <ChannelBadgeTooltip place="right" positionStrategy="fixed" html id={tooltipId} />
      )}
    </ChannelLabel>
  );
};

export default CurrentChannelBadge;
